import { useEffect } from "react";

import { Grid } from "@material-ui/core";
import { DckActionCreators } from "dck-redux";
import _get from "lodash/get";
import PropTypes from "prop-types";

import { ItemTypeApplication, useDispatchActions } from "srx-shared";
import { SelectField } from "srx-shared/mui";

import { RlSubmitStatus } from "@redux/items/types";

import { useStyles } from "./styles";

const actions = {
  loadErpDict: erp => DckActionCreators.itemsLoad(RlSubmitStatus, { erp }),
  resetErpDict: () =>
    DckActionCreators.setItemData(ItemTypeApplication, "rlSubmitStatus", [])
};

ErpSelect.propTypes = {
  field: PropTypes.object,
  fieldConfig: PropTypes.object,
  form: PropTypes.object,
  disabled: PropTypes.bool
};

export function ErpSelect(props) {
  const { field, fieldConfig, form, disabled } = props;

  const { name, label, size, options, checkHidden } = fieldConfig;

  const { loadErpDict, resetErpDict } = useDispatchActions(actions);

  const cls = useStyles();

  const value = field.value;
  const error = _get(form.errors, name);
  const touched = _get(form.touched, name);
  const isHidden = checkHidden(form);
  const helperTextProps = {
    classes: {
      root: cls.helperText,
      error: cls.helperTextError
    }
  };

  const handleChange = value => form.setFieldValue(name, value, true);

  useEffect(() => {
    value ? loadErpDict(value) : resetErpDict();
  }, [value, loadErpDict, resetErpDict]);

  return (
    !isHidden && (
      <Grid item xs={12} sm={size}>
        <SelectField
          fieldProps={{
            label,
            value,
            fullWidth: true,
            error: touched && Boolean(error),
            helperText: touched && error,
            disabled
          }}
          onChange={handleChange}
          options={options}
          FormHelperTextProps={helperTextProps}
        />
      </Grid>
    )
  );
}
